import React from 'react'
import MuiTextField from '@material-ui/core/TextField'

export function TextField(props) {
  return (
    <MuiTextField {...props} />
  )
}
